import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Grid from '@mui/material/Unstable_Grid2';
import { HotspotItem } from '../../models/LessonComponentContent';
import IconButton from '@mui/material/IconButton';
import ItemEditor from './ItemEditor';
import React from 'react';
import Typography from '@mui/material/Typography';
import styles from '../../styles/Hotspot.module.css';
import useThemes from '../../../shared/hooks/useThemes';

interface HotspotZoomedProps {
  componentkey: number;
  currentItem: HotspotItem;
  onChange: (hotspotItem: HotspotItem) => void;
  onZoomOut: () => void;
  onPreviousItem: () => void;
  onNextItem: () => void;
}

export default function HotspotZoomed(props: HotspotZoomedProps) {
  const { muiTheme } = useThemes();
  const fontFamily = muiTheme.typography.fontFamily;

  return (
    <div className={styles.textZoomed}>
      <Grid
        container
        direction={'column'}
        justifyContent="space-between"
        alignItems="center"
        style={{ height: '100%', fontFamily }}
      >
        <Grid
          container
          direction="column"
          wrap="nowrap"
          style={{
            width: '100%',
            flex: 11,
            overflowY: 'auto',
            marginTop: '15px'
          }}
          className="hotspotItemEditor"
        >
          <Grid
            style={{
              width: '100%',
              padding: '15px'
            }}
            className="hotspotTitleEditor"
          >
            <ItemEditor
              componentkey={props.componentkey}
              value={props.currentItem.heading}
              styleType="h2"
              placeholder="Click to edit title"
              onChange={(value) =>
                props.onChange({ ...props.currentItem, heading: value })
              }
            />
          </Grid>
          <Grid
            style={{
              width: '100%',
              padding: '15px'
            }}
            className="hotspotTextEditor"
          >
            <ItemEditor
              componentkey={props.componentkey}
              value={props.currentItem.body}
              styleType="p"
              placeholder="Click to edit text"
              onChange={(value) =>
                props.onChange({ ...props.currentItem, body: value })
              }
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="space-around"
          alignItems="center"
          style={{
            width: '100%',
            flex: 1
          }}
        >
          <Grid>
            <IconButton
              size="small"
              onClick={props.onPreviousItem}
              color="primary"
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          </Grid>
          <Grid>
            <Typography
              variant="overline"
              onClick={props.onZoomOut}
              style={{ cursor: 'pointer', fontWeight: 'bold' }}
              color="primary"
            >
              Zoom out
            </Typography>
          </Grid>
          <Grid>
            <IconButton size="small" onClick={props.onNextItem} color="primary">
              <ArrowForwardIcon fontSize="small" />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
